// Vendors
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import uuid from "react-native-uuid";
import { useTranslation } from "react-i18next";

// Components
import { Container } from "react-bootstrap";

// Styles
import "./RequestBirthRecord.scss";

// Navigation
import history from "./../../common/history";

// Components
import VerifyIdentityInState from "../../common/forms/verifyIdentity/VerifyIdentityInState";
import VerifyIdentityOutOfState from "../../common/forms/verifyIdentity/VerifyIdentityOutOfState";
import BirthCertificateInfo from "../../common/forms/birthRecordInfo/BirthCertificateInfo";
import { GetStartedBirthCertificate } from "../../common";

// Hooks
import useGlobal from "../../../store";

// Helpers
import GetCanonicalUrl from "../../common/GetCanonicalUrl";
import { GetRelationshipData, GetStateData, GetCountyData } from "referencedata";

function RequestBirthRecord() {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [globalState, globalActions] = useGlobal();
  const [arrayIndex, setArrayIndex] = useState("");

  const nextStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(currentStep + 1);

    value
      ? setUrlForForm("birthRecord", value)
      : setUrlForForm("birthRecord", currentStep + 1);
  };
  const prevStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(currentStep - 1);
    value
      ? setUrlForForm("birthRecord", value)
      : setUrlForForm("birthRecord", currentStep - 1);
  };

  const setUrlForForm = (record, step) => {
    if (record === "birthRecord") {
      switch (step) {
        case 0:
          history.push(t("URLS.ORDER_BIRTH_CERTIFICATE"));
          break;
        case 1:
          history.push(
            t("URLS.ORDER_BIRTH_CERTIFICATE") +
              t("URLS.VERIFY_IDENTITY_IN_STATE")
          );
          break;
        case 2:
          history.push(
            t("URLS.ORDER_BIRTH_CERTIFICATE") +
              t("URLS.VERIFY_IDENTITY_OUT_STATE")
          );
          break;
        case 3:
          history.push(
            t("URLS.ORDER_BIRTH_CERTIFICATE") +
              t("URLS.BIRTH_CERTIFICATE_INFORMATION")
          );
          break;
        default:
          history.push(t("URLS.ORDER_BIRTH_CERTIFICATE"));
      }
    }
  };

  const firstStep = (value) => {
    window.scrollTo(0, 0);
    value ? setCurrentStep(value) : setCurrentStep(0);
    value
      ? setUrlForForm("birthRecord", value)
      : setUrlForForm("birthRecord", 0);
  };
  useEffect(() => {
    if (!globalState.uniqueIdentifier) {
      globalActions.addUniqueIdentifier("OVRAREF_ID-" + uuid.v1());
    }
    globalActions.clearGlobalState();
    if (
      globalState.saveEditIndex.arrayIndex !== "" &&
      globalState.saveEditIndex.referenceType === "birthCertificate"
    ) {
      setArrayIndex(globalState.saveEditIndex.arrayIndex);
      globalState.getStartedBirthCertificateData.selectedState =
        globalState.totalOrderRecords[
          globalState.saveEditIndex.arrayIndex
        ].selectedState;
      globalState.getStartedBirthCertificateData.selectedRelation =
        globalState.totalOrderRecords[
          globalState.saveEditIndex.arrayIndex
        ].selectedRelation;
      globalState.getStartedBirthCertificateData.dateOfBirth = new Date(
        globalState.totalOrderRecords[
          globalState.saveEditIndex.arrayIndex
        ].dateOfBirth
      );
      globalState.birthCertificateInfoData =
        globalState.totalOrderRecords[globalState.saveEditIndex.arrayIndex];
    }
  }, []);

  return (
    <>
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <title>{t("BIRTH_CERTITICATE_INFORMATION.TITLE")}</title>
            <meta
              name="description"
              content={t("BIRTH_CERTITICATE_INFORMATION.META_CONTENT")}
            />

            <link
              rel="canonical"
              href={GetCanonicalUrl() + t("URLS.ORDER_BIRTH_CERTIFICATE_2")}
            />
          </Helmet>
          <Container className="lg-container">
            {currentStep === 0 && (
                <GetStartedBirthCertificate
                  stateList={GetStateData()}
                  relationList={GetRelationshipData(t("COMMON.LANGUAGE"),"Birth")}
                  nextCallback={nextStep}
                />
              )}
            {currentStep === 1 && (
              <VerifyIdentityInState
                stateList={GetStateData()}
                nextCallback={nextStep}
                prevCallback={prevStep}
                flowIndex="birthCertificate"
              />
            )}
            {currentStep === 2 && (
              <VerifyIdentityOutOfState
                stateList={GetStateData()}
                nextCallback={nextStep}
                prevCallback={firstStep}
                flowIndex="birthCertificate"
              />
            )}
            {currentStep === 3 && (
              <BirthCertificateInfo
                stateList={GetStateData()}
                countyList={GetCountyData()}
                editIndex={arrayIndex}
              />
            )}
          </Container>
        </div>
    </>
  );
}

export default RequestBirthRecord;
